import React, { useState, useEffect } from "react";
import "./index.css";

function Timer(props) {

    const [timerValue, setTimerValue] = useState(props.seconds);

    useEffect(() => {

        setTimerValue(props.seconds);
        const secondsCircle = document.getElementById("seconds_circle");
        const secondText = document.getElementById("second_text");

        function timerCountdown() {
            if (timerValue >= 0) {
                // Update the text content of the timer
                secondText.textContent = timerValue < 10 ? "0" + timerValue : timerValue;

                // Calculate strokeDashoffset based on the remaining time
                const strokeDashoffset = (1 - (timerValue / 20)) * 500;
                secondsCircle.style.strokeDashoffset = strokeDashoffset;

                // Decrease timer value by 1 second
                setTimerValue(prevTimerValue => prevTimerValue - 1);
            }
        }

        // Start the timer when the page loads
        timerCountdown();
    }, [props.seconds]);

    return (


                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"

                    viewBox="0 0 200 200"
                    className="svg-loaderT"
                >

                    <g>

                        {/* Gray circle under the second countdown circle */}
                        <circle fill="none" cx="50%" cy="50%" r="40%" transform="rotate(-89 100 100) scale(.8, .8) translate(25 25)" className="timer gray" style={{fill:"#0000004d"}}/>

                        {/* Second countdown circle */}
                        <circle id="seconds_circle" fill="none" cx="50%" cy="50%" r="40%" transform="rotate(-89 100 100) scale(.8, .8) translate(25 25)" className="svg-loader_growT" role="progressbar"/>
                        {/* Second countdown text */}
                        <text id="second_text" textAnchor="middle" x="49.5%" y="61%" fontFamily="'Open Sans', Verdana" fontSize="3em" fill="#fff">00</text>
                    </g>
                </svg>



    );
}
export default Timer;